// extracted by mini-css-extract-plugin
export default {"notice":"companyImpersonationNotice_notice__fT37P","dragging":"companyImpersonationNotice_dragging__s9M49","fixed-position":"companyImpersonationNotice_fixed-position__TxnRF"};